import React, { useState, useEffect } from 'react'
import Main from '../Components/Main'
import PageContainer from '../Components/PageContainer'
import Modal from '../Components/Modal'
import CollapseCard from '../Components/CollapseCard'
import { useToast } from '../Components/toast/ToastProvider'
import { getAllFixedSources, saveFixedSource } from '../Service/FixedSourceService'
import FixedSourceForm from '../Components/FixedSourceForm'
import FixedSourceList from '../Components/FixedSourceList'

const FixedSourcePage = () => {
  const [fixedSourceData, setFixedSourceData] = useState([])
  const [fixedSourceForm, setFixedSourceForm] = useState({ title: '' })
  const [showModal, setShowModal] = useState(false);
  const toast = useToast();

  useEffect(() => {
    fetchSources()
  }, [])

  const fetchSources = async () => {
    try {
      const res = await getAllFixedSources()
      setFixedSourceData(res.data)
    } catch (err) {
      toast(err.message || 'Failed to fetch Fixed Source')
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!fixedSourceForm.title) return alert('Please fill the Fixed source name')

      const duplicateName = fixedSourceData.some((i)=> i.id !== fixedSourceForm.id && i.title.trim().toLowerCase() === fixedSourceForm.title.trim().toLowerCase());
      if(duplicateName){
        toast("Fixed Source Name already exist","ERROR");
        return;
      }

    try {
      const payload = fixedSourceForm.id ? {id:fixedSourceForm.id,title:fixedSourceForm.title}:{title:fixedSourceForm.title}
      await saveFixedSource(payload);
      toast(fixedSourceForm.id? 'Fixed Source update successfully':'Fixed Source added successfully');
      fetchSources()
      handleCancel()
    } catch (err) {
      alert(err.message || 'Failed to save Fixed Source',"ERROR")
    }
  }

  const handleEdit = (item) => {
    setFixedSourceForm({id:item.id,title:item.title})
    setShowModal(true);
  }

  // const handleDelete = async (index) => {
  //   if (!window.confirm('Are you sure you want to delete this Fixed Source?')) return
  //   try {
  //     await deleteFixedSource(fixedSourceData[index].id)
  //     toast('Fixed Source deleted successfully!', "SUCCESS")
  //     fetchSources()
  //   } catch (err) {
  //     toast(err.message || 'Failed to delete source',"ERROR")
  //   }
  // }

  const handleChange = (e) => {
    const { name, value } = e.target
    setFixedSourceForm((prev) => ({ ...prev, [name]: value }))
  }

  const handleCancel = () => {
    setFixedSourceForm({ title: '' })
    setShowModal(false)
  }

  return (
    <Main>
      <PageContainer
        titlePage="FixedSource"
        buttonText="ADD"
        onButtonClick={() => setShowModal(true)}
      >
        <Modal
          visible={showModal}
          size="lg"
          onClose={handleCancel}
          headerText={fixedSourceForm.id ? "Edit Fixed Source" : "Add Fixed Source"}
        >
          <FixedSourceForm
            handleChange={handleChange}
            fixedSourceForm={fixedSourceForm}
            handleSubmit={handleSubmit}
            handleCancel={handleCancel}
          />
        </Modal>

        <CollapseCard title='Fixed Source'>
          <FixedSourceList
            fixedSourceData={fixedSourceData}
            handleEdit={handleEdit}
            // handleDelete={handleDelete}
          />
        </CollapseCard>
      </PageContainer>
    </Main>
  )
}

export default FixedSourcePage
